export function ensureTicketAudioDuration(audio: HTMLAudioElement): void {
  if (Number.isFinite(audio.duration) && audio.duration > 0) return;

  const resetToStart = () => {
    audio.removeEventListener('timeupdate', resetToStart);
    audio.currentTime = 0;
  };

  audio.addEventListener('timeupdate', resetToStart);
  try {
    // MediaRecorder WebM files can omit duration metadata. Seeking to the end
    // makes Chromium calculate the duration without requiring playback.
    audio.currentTime = Number.MAX_SAFE_INTEGER;
  } catch {
    audio.removeEventListener('timeupdate', resetToStart);
  }
}
